module.exports = {

    role: {
        PARTICIPANT: 3,
        ORGANIZER: 1
    },

    noteAccess: {
        PRIVATE: 1,
        PUBLIC: 2
    },
};